import React from "react";
import styles from "./HelpCenterHero.module.css";
import illustration from "../../../Images/Healthcare_img.png"; // replace with your image

const HelpCenterHero = () => {
    return (
        <section className={styles.section}>
            <div className={styles.wrapper}>

                {/* LEFT CONTENT */}
                <div className={styles.left}>
                    <h1>
                        Transform Healthcare <br />
                        with AI-Driven <br />
                        Support
                    </h1>

                    <p>
                        ToxBox AI delivers intelligent patient support,<br />
                        appointment management, and HIPAA-compliant AI <br />
                        solutions for healthcare providers
                    </p>

                    <div className={styles.buttons}>
                        <button className={styles.primary}>Request a Demo</button>
                        <button className={styles.secondary}>Get Started</button>
                    </div>
                </div>

                {/* RIGHT ILLUSTRATION */}
                <div className={styles.right}>
                    <img src={illustration} alt="Healthcare AI Illustration" />
                </div>

            </div>
        </section>
    );
};

export default HelpCenterHero;
